import React from 'react';
import PropTypes from 'prop-types';
import { upperFirst } from 'lodash';
import SimpleCheckbox from '../../simpleCheckbox';

const Row = ({ action, className, disabled, hide, label }) => (
  <div className={className}>
    <div className="c-label c-label--light u-mv--">{label}</div>
    {['email', 'phone', 'push'].map((field) => {
      if (hide && hide.includes(field)) {
        return null;
      }

      return (
        <SimpleCheckbox
          disabled={disabled}
          key={field}
          label={upperFirst(field)}
          id={`${action}_${field}`}
          name={`${action}.${field}`}
        />
      );
    })}
  </div>
);
Row.propTypes = {
  action: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hide: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
};
Row.defaultProps = {
  className: '',
  disabled: false,
  hide: [],
};

export default Row;
